/**
 * Checks each column container for invalid inputs and adds a custom class if found.
 * @param {HTMLFormElement} form
 */
export function validateFormColumns(form) {
    const containers = form.querySelectorAll('[class*="col-"]');

    if (!form || !containers) {
        return;
    }

    setTimeout(() => {
        for (let index = 0; index < containers.length; index++) {
            const element = containers[index];
            const input = element.querySelector('.wpcf7-form-control');

            if (!input) continue;

            element.classList.remove('not-valid');

            if (input.classList.contains('wpcf7-not-valid')) {
                element.classList.add('not-valid');
            }
        }
    }, 50);
}

/**
 * Initializes Contact Form 7 validation event listeners.
 * Call this in app.js after importing.
 */
export function initFormValidation() {
    document.addEventListener('wpcf7invalid', function (event) {
        const form = event.target;
        validateFormColumns(form);
    }, false);

    // If you use jQuery, ensure it's loaded before calling this
    if (window.jQuery) {
        window.jQuery(document).on('focusout', '.wpcf7-form-control', function () {
            var form = window.jQuery(this).closest('form');
            if (!form.length) return;
            validateFormColumns(form[0]);
        });
    }
}

/**
 * Adds or removes a 'filled' class to inputs, selects, and textareas based on their value.
 * @param {HTMLElement} element
 */
function updateFilledClass(element) {
    if (
        (element.tagName === 'INPUT' && element.type !== 'checkbox' && element.type !== 'radio') ||
        element.tagName === 'SELECT' ||
        element.tagName === 'TEXTAREA'
    ) {
        if (element.value && element.value.trim() !== '') {
            element.classList.add('filled');
        } else {
            element.classList.remove('filled');
        }
    }
}

/**
 * Initializes filled state listeners for form fields.
 * Call this in app.js after importing.
 */
export function initFilledInputs() {
    document.addEventListener('input', function (event) {
        updateFilledClass(event.target);
    });

    document.addEventListener('change', function (event) {
        updateFilledClass(event.target);
    });

    // Initialize on page load for pre-filled fields
    document.querySelectorAll('input, select, textarea').forEach(updateFilledClass);
}
